/**
 * @generated SignedSource<<6b3b176260c8b12501f06ed0294726cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddModelListModelInput = {
  modelId: string;
  modelListId: string;
};
export type MainAddModelListModelMutation$variables = {
  input: AddModelListModelInput;
};
export type MainAddModelListModelMutation$data = {
  readonly addModelListModel: {
    readonly modelList: {
      readonly id: string;
    };
  };
};
export type MainAddModelListModelMutation = {
  response: MainAddModelListModelMutation$data;
  variables: MainAddModelListModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddModelListModelPayload",
    "kind": "LinkedField",
    "name": "addModelListModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelList",
        "kind": "LinkedField",
        "name": "modelList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MainAddModelListModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MainAddModelListModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77dd6b76c55b937ad8a500cbfa78e850",
    "id": null,
    "metadata": {},
    "name": "MainAddModelListModelMutation",
    "operationKind": "mutation",
    "text": "mutation MainAddModelListModelMutation(\n  $input: AddModelListModelInput!\n) {\n  addModelListModel(input: $input) {\n    modelList {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e0de97c638bd61d26c4e5d94648dcf5";

export default node;
